<button
  mat-flat-button
  color="blue"
  class="qaroni-rounded-button w-full"
  routerLink="details"
  [queryParams]="frequencyParam">
  <mat-icon class="me-2">check_circle</mat-icon>
  <ng-container i18n>Subscribirme</ng-container>
</button>
